import React, { useEffect, useState } from "react";
import { FaRegEye, FaRegEyeSlash } from "react-icons/fa";
import { PiWarningCircleLight } from "react-icons/pi";
import {
  RiCheckboxBlankCircleLine,
  RiCheckboxCircleFill,
} from "react-icons/ri";
import { Link, useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { serverInstance } from "../../service/axios";
import { resolveSafeReturnPath } from "../../utils/resolveSafeReturnPath";
import "./sign.scss";

const SignUp = ({ data }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const returnPath = resolveSafeReturnPath(location.state, searchParams, "/membership");

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const [loading, setLoading] = useState(false); //TODO
  const [errorMsg, setErrorMsg] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [step, setStep] = useState(1);
  const [formData, setFormData] = useState({
    first_name: "",
    last_name: "",
    email: "",
    mobile_number: "",
    graduated_year: "",
    institution: "",
    diploma_number: "",
    occupation: "",
    workplace: "",
    job: "",
    social_address: "",
    password: "",
    repassword: "",
    agreedTC: false,
  });
  const nextStep = () => {
    if (validate()) {
      if (step < 4) setStep((prev) => prev + 1);
    }
  };
  const previousStep = () => {
    if (step > 1) setStep((prev) => prev - 1);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!validate()) return;

    formData.email = formData.email.toLowerCase();

    serverInstance
      .post("/client/signup", formData)
      .then((response) => {
        localStorage.setItem("msidclienttoken", response.data.token);
        navigate(returnPath);
      })
      .catch((err) => {
        const errorMessage = err?.response?.data?.message;
        
        if (errorMessage === "EMAIL_REGISTERED_ALREADY") {
          setErrorMsg(data.emailAlreadyRegistered);
        } else if (errorMessage === "MOBILE_REGISTERED_ALREADY") {
          setErrorMsg(data.mobileAlreadyRegistered);
        } else {
          setErrorMsg(errorMessage || "Бүртгүүлэхэд алдаа гарлаа");
        }
      })
      .finally(() => setLoading(false));
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
    setErrorMsg("");
  };

  const validate = () => {
    if (step === 2) {
      const yearPattern = /^(19|20)\d{2}$/;
      if (!formData.institution.trim()) {
        setErrorMsg(data.institutionRequired);
        return false;
      }
      if (!yearPattern.test(formData.graduated_year)) {
        setErrorMsg(data.invalidYear);
        return false;
      }
      if (!formData.diploma_number.trim()) {
        setErrorMsg(data.diploma_numberRequired);
        return false;
      }
      if (!formData.occupation.trim()) {
        setErrorMsg(data.occupationRequired);
        return false;
      }
      if (!formData.job.trim()) {
        setErrorMsg(data.jobRequired);
        return false;
      }
      return true;
    }

    if (step === 3) {
      const mobilePattern = /^[0-9]{8}$/;
      if (!formData.last_name.trim()) {
        setErrorMsg(data.last_nameRequired || "Овог оруулна уу");
        return false;
      }
      if (!formData.first_name.trim()) {
        setErrorMsg(data.first_nameRequired || "Нэр оруулна уу");
        return false;
      }
      if (
        !formData.email.trim() ||
        !/^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(formData.email)
      ) {
        setErrorMsg(data.invalidEmail);
        return false;
      }
      if (!mobilePattern.test(formData.mobile_number)) {
        setErrorMsg(data.invalidMobile);
        return false;
      }
      if (!formData.workplace.trim()) {
        setErrorMsg(data.workplaceRequired);
        return false;
      }
      return true;
    }

    if (step === 4) {
      const minLength = 8;
      const hasUpperCase = /[A-Z]/.test(formData.password);
      const hasLowerCase = /[a-z]/.test(formData.password);
      const hasNumbers = /\d/.test(formData.password);

      if (formData.password.length < minLength) {
        setErrorMsg(data.passwordLength);
        return false;
      }
      if (!hasUpperCase || !hasLowerCase || !hasNumbers) {
        setErrorMsg(data.passwordRequirement);
        return false;
      }
      if (formData.password !== formData.repassword) {
        setErrorMsg(data.passwordNotMatch);
        return false;
      }
      if (!formData.agreedTC) {
        setErrorMsg(data.mustAgree);
        return false;
      }
      return true;
    }

    return true;
  };

  return (
    <div className="sign-container">
      <div className="sign-container-card">
        <div className="sign-line-container">
          <div className="sign-line" />
          {step > 1 ? (
            <div className="sign-line" />
          ) : (
            <div className="sign-line2" />
          )}
          {step > 2 ? (
            <div className="sign-line" />
          ) : (
            <div className="sign-line2" />
          )}
          {step > 3 ? (
            <div className="sign-line" />
          ) : (
            <div className="sign-line2" />
          )}
        </div>
        <h2>{data.signup}</h2>
        <div>
          {/* {loading ? <Dimmer /> : null} */}
          {step === 1 && (
            <div className="sign-container-card-content">
              <img
                alt="doctors"
                className="doctorsImg"
                src="/images/doctors.png"
                style={{ width: 276, height: 276 }}
              />
              <p className="sign-info-text">{data.information}</p>
              <button className="sign-button" onClick={nextStep}>
                {data.continue}
              </button>
            </div>
          )}
          {step === 2 && (
            <form onSubmit={handleSubmit}>
              <h5>{data.educationInfo}</h5>
              <div className="form-div">
                <label className="sign-label">{data.institution}</label>
                <input
                  type="text"
                  name="institution"
                  value={formData.institution}
                  onChange={handleChange}
                  required
                  className="sign-input"
                />
              </div>
              <div className="form-div">
                <label className="sign-label">{data.graduated_year}</label>
                <input
                  type="text"
                  name="graduated_year"
                  value={formData.graduated_year}
                  onChange={handleChange}
                  required
                  className="sign-input"
                />
              </div>
              <div className="form-div">
                <label className="sign-label">{data.diploma_number}</label>
                <input
                  type="text"
                  name="diploma_number"
                  required
                  value={formData.diploma_number}
                  onChange={handleChange}
                  className="sign-input"
                />
              </div>
              <div className="form-div">
                <label className="sign-label">{data.occupation}</label>
                <input
                  type="text"
                  name="occupation"
                  value={formData.occupation}
                  onChange={handleChange}
                  required
                  className="sign-input"
                />
              </div>
              <div className="form-div">
                <label className="sign-label">{data.job}</label>
                <input
                  type="text"
                  name="job"
                  value={formData.job}
                  onChange={handleChange}
                  required
                  className="sign-input"
                />
              </div>
              {errorMsg ? (
                <div className="form-div error-msg">
                  <PiWarningCircleLight /> {errorMsg}
                </div>
              ) : null}
              <div className="form-div-row error">
                <br />
                <button
                  type="button"
                  className="sign-button3"
                  onClick={previousStep}
                >
                  {data.back}
                </button>
              </div>
              <div className="form-div-row error">
                <br />
                <button
                  type="button"
                  className="sign-button"
                  onClick={nextStep}
                >
                  {data.continue}
                </button>
              </div>
              <br />
            </form>
          )}
          {step === 3 && (
            <form onSubmit={handleSubmit}>
              <h5>{data.personalInfo}</h5>
              <div className="flex-row">
                <div className="form-div" style={{ marginRight: "10px" }}>
                  <label className="sign-label">{data.lname}</label>
                  <input
                    type="text"
                    name="last_name"
                    value={formData.last_name}
                    onChange={handleChange}
                    required
                    className="sign-input"
                  />
                </div>
                <div className="form-div" style={{ marginLeft: "10px" }}>
                  <label className="sign-label">{data.fname}</label>
                  <input
                    type="text"
                    name="first_name"
                    value={formData.first_name}
                    onChange={handleChange}
                    required
                    className="sign-input"
                  />
                </div>
              </div>

              <div className="form-div">
                <label className="sign-label">{data.email}</label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  autoCapitalize="none"
                  className="sign-input"
                />
              </div>
              <div className="form-div">
                <label className="sign-label">{data.mnumber}</label>
                <input
                  type="tel"
                  name="mobile_number"
                  pattern="[0-9]{8}"
                  value={formData.mobile_number}
                  onChange={handleChange}
                  required
                  className="sign-input"
                />
              </div>

              <div className="form-div">
                <label className="sign-label">{data.workplace}</label>
                <input
                  type="text"
                  name="workplace"
                  value={formData.workplace}
                  onChange={handleChange}
                  required
                  className="sign-input"
                />
              </div>
              <div className="form-div">
                <label className="sign-label">{data.social_address}</label>
                <input
                  type="text"
                  name="social_address"
                  value={formData.social_address}
                  onChange={handleChange}
                  className="sign-input"
                />
              </div>

              {errorMsg ? (
                <div className="form-div error-msg">
                  <PiWarningCircleLight /> {errorMsg}
                </div>
              ) : null}
              <div className="form-div-row error">
                <br />
                <button
                  type="button"
                  className="sign-button3"
                  onClick={previousStep}
                >
                  {data.back}
                </button>
              </div>
              <div>
                <br />
                <button
                  type="button"
                  className="sign-button"
                  onClick={nextStep}
                >
                  {data.continue}
                </button>
              </div>
            </form>
          )}
          {step === 4 && (
            <form onSubmit={handleSubmit}>
              <h5>{data.password}</h5>
              <div className="form-div">
                <label className="sign-label">{data.password}</label>
                <div className="password-container">
                  <input
                    type={showPassword ? "text" : "password"}
                    name="password"
                    value={formData.password}
                    onChange={handleChange}
                    required
                    className="sign-input"
                  />
                  {showPassword ? (
                    <FaRegEye
                      type="button"
                      onClick={() => setShowPassword(!showPassword)}
                      className="password-toggle"
                    />
                  ) : (
                    <FaRegEyeSlash
                      type="button"
                      onClick={() => setShowPassword(!showPassword)}
                      className="password-toggle"
                    />
                  )}
                </div>
              </div>
              <div className="form-div">
                <label className="sign-label">{data.repassword}</label>
                <input
                  type={showPassword ? "text" : "password"}
                  name="repassword"
                  value={formData.repassword}
                  onChange={handleChange}
                  required
                  className="sign-input"
                />
              </div>

              <div className="form-div">
                <br />
                <div
                  onClick={() =>
                    setFormData({ ...formData, agreedTC: !formData.agreedTC })
                  }
                  style={{
                    cursor: "pointer",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  {formData.agreedTC ? (
                    <RiCheckboxCircleFill color="green" size={30} />
                  ) : (
                    <RiCheckboxBlankCircleLine size={30} />
                  )}
                  <div style={{ marginLeft: "15px" }}>
                    <span
                      onClick={() =>
                        setFormData({ ...formData, agreedTC: true })
                      }
                    >
                      {data.terms}
                    </span>

                    <Link to={"/terms"} target="_blank" className="terms-link">
                      {data.link}
                    </Link>
                  </div>
                </div>
              </div>
              {errorMsg ? (
                <div className="form-div error-msg">
                  <PiWarningCircleLight /> {errorMsg}
                </div>
              ) : null}
              <br />
              <div className="form-div-row error">
                <button
                  type="button"
                  className="sign-button3"
                  onClick={previousStep}
                >
                  {data.back}
                </button>
              </div>
              <br />
              <div className="form-div-row-error">
                <button className="sign-button" onClick={handleSubmit}>
                  {data.signup}
                </button>{" "}
              </div>
            </form>
          )}
        </div>
      </div>
    </div>
  );
};
export default SignUp;
